<template>
  <div class="main">
    <router-view />
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  min-height: calc(100vh - 200px);
  // height: 1000px;
}
</style>
